<template>
  <div>
    <question-renderer :question="src" :indicator="indicator"></question-renderer>

    <!-- <v-divider class="my-3"></v-divider> -->
    <div class="pt-1 wysiwyg-content" id="choices-block">
      <v-textarea
        hide-details
        outlined
        placeholder="กรุณาพิมพ์คำตอบลงในช่องว่าง"
        v-model="answer"
        :readonly="readOnly"
        :error="setColor(answer) == 'error'"
        :success="setColor(answer) == 'success'"
      ></v-textarea>
    </div>

    <v-expand-transition>
      <div v-if="showCorrectAnswer" class="mt-4">
        <div class="subtitle-1 font-weight-bold">คำตอบที่ถูกต้อง</div>
        <v-card class="my-3">
          <v-list dense>
            <template v-for="(item, idx) of correctAnswer.correctText">
              <v-divider v-show="idx > 0" :key="`divider_correctAns_${idx}`"></v-divider>
              <v-list-item :key="`correctAns_${idx}`">
                <v-list-item-content v-text="item"></v-list-item-content>
                <!-- <v-list-item-action>
                    <v-icon small color="success">far fa-check</v-icon>
                </v-list-item-action>-->
              </v-list-item>
            </template>
          </v-list>
        </v-card>
        <!-- <v-divider class="my-3"></v-divider> -->
        <v-alert
          text
          type="info"
          :icon="false"
          v-if="correctAnswer.note != null && correctAnswer.note != ''"
        >
          <div class="subtitle-1 font-weight-bold">
            <v-icon color="info" left>far fa-info-circle</v-icon>เพิ่มเติม
          </div>
          <v-divider class="my-3 info" style="opacity:.2"></v-divider>
          <div v-html="correctAnswer.note"></div>
        </v-alert>
      </div>
    </v-expand-transition>
  </div>
</template>

<script>
import QuestionRenderer from "@/components/QuestionRenderer.vue";
export default {
  name: "ComplementExam",
  props: ["src", "userAnswer", "correctAnswer", "indicator"],
  data: () => ({
    answer: "",
  }),
  components: {
    QuestionRenderer,
  },
  computed: {
    showCorrectAnswer() {
      if (
        this.correctAnswer != null &&
        this.correctAnswer.correctText.length != 0
      ) {
        this.$nextTick(() => {
          if (this.$store.state.showCorrectAnswer == false) {
            this.$vuetify.goTo("#choices-block");
          }
        });
        return true;
      }
      return false;
    },
    readOnly() {
      return this.$store.state.readOnly;
    },
  },
  watch: {
    answer(val) {
      const data = {
        answer: val,
      };
      this.$emit("interact", data);
    },
  },
  mounted() {
    this.answer = "";
    this.init();
  },
  methods: {
    setColor(value) {
      if (this.showCorrectAnswer === true) {
        // console.log(
        //   value,
        //   this.correctAnswer.correctText.findIndex(x => x == value)
        // );
        if (this.correctAnswer.correctText.findIndex((x) => x == value) != -1) {
          return "success";
        } else {
          return "error";
        }
      }
      return "primary";
    },
    setColorText(value) {
      if (this.showCorrectAnswer === true) {
        if (
          this.correctAnswer.correctText.findIndex((x) => x._id == value) != -1
        ) {
          return ["success--text"];
        } else {
          return ["error--text"];
        }
      }
      return [""];
    },
    init() {
      // console.log("init multiple q", this.src);
      // console.log(this.userAnswer);

      if (this.userAnswer != null) {
        this.answer = this.userAnswer;
      }
    },
    getAnswer() {
      return this.answer;
    },
  },
};
</script>